import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "clm-act-cntn" }
const _hoisted_3 = ["onClick"]

import { getCurrentInstance, onMounted, ref } from 'vue'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import InputSwitch from 'primevue/inputswitch'
import OverlayPanel from 'primevue/overlaypanel'
import ProgressSpinner from 'primevue/progressspinner'
import EmptyState from '@/views/components/list/EmptyState.vue'
import Paginator from '@/views/components/paginator/Paginator.vue'
import ListActions from '@/views/components/list/ListActions.vue'
import { Form, Field } from 'vee-validate'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'

const positionEndpoint = 'talent/v1/positions'
const documentEndpoint = 'talent/v1/positions/:id/documentRequirements'

export default /*@__PURE__*/_defineComponent({
  __name: 'PositionTab',
  setup(__props) {

const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const requirementId = ref()
const requirementEndpoint = ref(`talent/v1/positions/${requirementId.value}/requirements`)
const dataSource = ref([]) as any
const isLoading = ref(false)
const emptyTable = ref('Data belum ada, silahkan tambah untuk mengisi data')
const headerTitle = ref('Tambah Daftar Divisi')
const buttonTitle = ref('')
const searchPlaceholder = ref('Cari Disini...')
const showConfirmDialog = ref(false)
const showForm = ref(false)
const dataRow = ref(null) as any
const refOverlayAction = ref()
const router = useRouter()
const filters = {
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  search: '',
  filterField: ['name']
}

const confirmDialogDelete = {
  title: 'Hapus Daftar Divisi?',
  subTitle: 'Data daftar Divisi tersebut akan dihapus dalam sistem. Yakin hapus daftar Divisi?',
  btnSubmitTitle: 'Hapus daftar Divisi'
}

const onSort = (val: any) => {
  console.log('onSort', val)
}

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${positionEndpoint}${returnUrlPrams(filters)}`).then((response) => {
    const {
      error,
      result
    } = response
    if (!error) {
      console.log('result', result)
      dataSource.value = result.data
      filters.totalRecords = result.count
    }
  })
  store.dispatch('hideLoading')
}

const onSearch = (value: any) => {
  filters.search = value
  filters.pageNumber = 1
  getAllData()
}

const onClickBtnAdd = () => {
  router.push({
    name: 'master-position-form'
  })
}

const closeForm = () => {
  showForm.value = false
}

const reloadParentAct = () => {
  getAllData()
}

const onChangePage = (val: any) => {
  filters.pageNumber = val.page + 1
  getAllData()
}

const onDelete = () => {
  console.log('del')
  showConfirmDialog.value = true
}

const hideDialogConfirmation = () => {
  showConfirmDialog.value = false
}

const processDelete = async () => {
  store.dispatch('showLoading')
  await apiUseCase.delete(positionEndpoint, dataRow.value.id).then((response) => {
    const { error, result, message } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        summary: 'Divisi berhasil dihapus',
        detail: 'Data Divisi berhasil dihapus dari dalam sistem',
        group: 'bc',
        closable: false,
        life: 3000
      })
      hideDialogConfirmation()
      getAllData()
    } else {
      $toast.add({
        severity: 'error',
        summary: result?.title ?? 'Divisi gagal dihapus',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const onEdit = () => {
  console.log('edit')
  router.push({
    name: 'master-position-form',
    params: {
      id: encryptDecriptMethods.encrypt(dataRow.value)
    }
  })
}

const onShowDetail = () => {
  console.log('detail')
}

const showDropDown = (evt: any, item: any) => {
  dataRow.value = item
  console.log('dataRow', dataRow.value)
  refOverlayAction.value.toggle(evt)
}

onMounted(() => {
  getAllData()
})

const requirementOptions = ref([
  {
    id: '01972f23-9cda-7294-b1dd-422057bf4a4a',
    documentTypeId: '01970b07-a1fa-7ab4-8706-1ba87bd5b0a0',
    documentTypeName: 'KTP',
    isRequired: true
  }
])

const documentOptions = ref([
  {
    id: '0197a611-d8f1-7adc-b3ec-a4df66d6377a',
    requirementName: 'Umur',
    requirementDataType: 'Integer',
    description: 'Umur',
    dataValue: '25'
  }
])

const selectedPositionId = ref()

function requirementEndpointbyId(id: string): string {
  console.log(`talent/v1/positions/${id}/requirements`)
  return `talent/v1/positions/${id}/requirements`
}

const endpointPositions = ref('talent/v1/positions')

const ambilData = (id: any) => {
  selectedPositionId.value = id
  console.log('ambilData', id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(HeaderCustom, {
            titleHeader: headerTitle.value,
            buttonTitle: buttonTitle.value,
            showAddBtn: true,
            onRedirectAdd: onClickBtnAdd,
            placeholder: searchPlaceholder.value,
            onOnSearch: onSearch,
            showSearch: true
          }, null, 8, ["titleHeader", "buttonTitle", "placeholder"])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(DataTable), {
          id: "hjp-data-table",
          value: dataSource.value,
          paginator: false,
          loading: isLoading.value,
          class: "table-og hjp-data-table",
          onSort: onSort
        }, {
          empty: _withCtx(() => [
            _createVNode(EmptyState, { textNoData: emptyTable.value }, null, 8, ["textNoData"])
          ]),
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), { header: "Nama Divisi" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Kode Divisi" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.code ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Persyaratan Umum" }, {
              body: _withCtx((slotProps) => [
                _createVNode(_unref(Field), { name: "Requirement" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(SelectFetch, _mergeProps(field, {
                      inputId: `requirement`,
                      endpoint: `${endpointPositions.value}/${slotProps.data.id}/requirements`,
                      fieldLabel: (v) => `${v.requirementName} - ${v.dataValue}`,
                      clearable: false,
                      searchFields: ['requirementName'],
                      options: requirementOptions.value,
                      placeholder: `Lihat Persyaratan Umum`,
                      classname: 'custom-select'
                    }), null, 16, ["endpoint", "fieldLabel", "options"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Dokumen yang Dibutuhkan" }, {
              body: _withCtx((slotProps) => [
                _createVNode(_unref(Field), { name: "Document" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(SelectFetch, _mergeProps(field, {
                      inputId: `document`,
                      endpoint: `${endpointPositions.value}/${slotProps.data.id}/documentRequirements`,
                      fieldLabel: (v) => `${v.documentTypeName}`,
                      clearable: false,
                      searchFields: ['documentTypeName'],
                      options: requirementOptions.value,
                      placeholder: `Lihat Dokumen`,
                      classname: 'custom-select'
                    }), null, 16, ["endpoint", "fieldLabel", "options"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              class: "colom-action mx-auto",
              header: ""
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: "px-4 py-2 flex items-center cursor-pointer rounded-lg",
                    onClick: ($event: any) => (showDropDown($event, slotProps.data))
                  }, _cache[0] || (_cache[0] = [
                    _createElementVNode("i", {
                      class: "pi pi-ellipsis-h",
                      style: {"font-size":"1rem"}
                    }, null, -1)
                  ]), 8, _hoisted_3)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ]),
      footer: _withCtx(() => [
        (filters.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: filters.pageSize,
              totalRecords: filters.totalRecords,
              onOnPage: onChangePage
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayAction",
      ref: refOverlayAction
    }, {
      default: _withCtx(() => [
        _createVNode(ListActions, {
          edit: true,
          del: true,
          showDetail: false,
          editTitle: 'Edit',
          delTitle: 'Hapus',
          showDetailTitle: 'Detail',
          onDel: onDelete,
          onEdit: onEdit
        })
      ]),
      _: 1
    }, 512),
    _createVNode(HjpCofirmModal, {
      show: showConfirmDialog.value,
      title: confirmDialogDelete?.title,
      subTitle: confirmDialogDelete?.subTitle,
      btnSubmitTitle: confirmDialogDelete?.btnSubmitTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: processDelete
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})